(ns renolit-roofing-service.view.session.login
  (:require [dev.gethop.session.re-frame.cognito.action.login :as cognito.login]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.layout.session :as layout.session]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.domain.miscellaneous :as dom.misc]
            [renolit-roofing-service.user :as client.user]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.rae-home :as view.rae-home]
            [renolit-roofing-service.view.installer-home :as view.installer-home]
            [renolit-roofing-service.view.session.register-details :as view.register-details]))

(def ^:const view-context
  :login-view)

(def ^:const route-config
  {:name [:login]})

(def ^:const form-schema
  [:map
   [:username
    dom.misc/email-schema]
   [:password
    [:string]]])

(rf/reg-event-fx
 ::fetch-user-failure
 (fn [_ [_ result]]
   (let [reason (get-in result [:response :reason])]
     (if (= :not-found reason)
       {:dispatch [::nav/push-state (:name view.register-details/route-config)]}
       {:dispatch-n [[::util/generic-error reason]
                     [::layout.info-bar/add-info-bar {:context view-context
                                                      :disappear-in-ms 5000
                                                      :type :error
                                                      :msg-transl-kw (t [:error-msg.unknown])}]]}))))

(rf/reg-event-fx
 ::login-user-loaded
 (fn [{:keys [db]} [_ user]]
   (let [route (if (= :installer (:role user))
                 (:name view.installer-home/route-config)
                 (:name view.rae-home/route-config))]
     {:dispatch [::nav/push-state route]})))

(rf/reg-event-fx
 ::login-success
 (fn [_ _]
   {:dispatch [::client.user/fetch-user-data
               {:on-success-evt [::login-user-loaded]
                :on-failure-evt [::fetch-user-failure]}]}))

(rf/reg-event-fx
 ::login-failure
 (fn [_ [_ reason]]
   {:dispatch-n [[::util/generic-error reason]
                 [::layout.info-bar/add-info-bar {:context view-context
                                                  :disappear-in-ms 5000
                                                  :type :error
                                                  :msg-transl-kw
                                                  (condp = reason
                                                    :incorrect-username-or-password
                                                    (t [:error-msg.incorrect-username-or-password])
                                                    (t [:error-msg.unknown]))}]]}))

(defn- on-form-submit
  [state]
  (let [credentials (m/encode form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors form-schema credentials)]
    (if form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])
      (do (rf/dispatch [::form.error/clear-errors view-context])
          (rf/dispatch [::cognito.login/user-login
                        credentials
                        {:on-success-evt [::login-success]
                         :on-failure-evt [::login-failure]}])))))

(defn- main
  []
  (let [state (r/atom {})
        password-visible? (r/atom false)]
    (fn []
      [layout.session/layout
       [:<>
        [:div.session_main-description
         [:h3.session_main-description-title
          (t [:page.login.title])]
         [:span.session_main-description-subtitle
          (t [:page.login.subtitle])]]
        [:form.simple-form.login_form
         {:on-submit
          (fn [e]
            (.preventDefault e)
            (on-form-submit state))}
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :path [:username]
           :mandatory? true
           :label-transl-kw :label/email
           :placeholder-transl-kw :placeholder.email
           :schema [:string]}]
         [layout.form/item
          (cond-> {:context view-context
                   :type :input
                   :state state
                   :path [:password]
                   :mandatory? true
                   :css-class-prefix "password_input"
                   :icon-kw (if @password-visible? :eye-slash :eye)
                   :on-icon-click #(swap! password-visible? not)
                   :label-transl-kw :label.password
                   :placeholder-transl-kw :placeholder.password
                   :schema [:string]}
            (not @password-visible?) (assoc :input-type :password))]
         [:a.forgot-pass
          {:href (nav/href [:forgot-password])}
          (t [:page.login.forgot-password-link])]
         [:div.simple-form__actions
          [:button.btn.btn--primary
           {:type :submit}
           (t [:button.login])]]
         [:div.session_register-link
          (t [:page.login.register-text])
          " "
          [:a
           {:href (nav/href [:register])}
           (t [:page.login.register-link])]]]]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
